const regionName = (region) => {
  switch (region) {
    case 'PT-MA':
      return 'Madeira';
    case 'PT-AC':
      return 'Açores';
    default:
      return '';
  }
}

/**
 * Gera o label para exibição de um imposto em selects/dropdowns.
 * Impostos com reason (isenção): "(não usar) - " se code < 100, depois "Isenção - {reason} - {name} - {description}".
 * Caso contrário: "{tax}%".
 *
 * @param {{ code: number, tax?: number, reason?: string, name?: string, description?: string }} tax
 * @returns {string}
 */
export function getTaxSelectLabel(tax) {
  if (tax.reason) {
    const prefix = tax.code < 100 ? '(não usar) - ' : '';
    return `${prefix}Isenção - ${tax.reason} - ${tax.name} - ${tax.description}`;
  }
  if (tax.country_region && regionName(tax.country_region) !== '') {
    return `${tax.tax}% (${regionName(tax.country_region)})`;
  }
  return `${tax.tax}%`;
}
